export class AiModel {
  ModelId: number;
  ModelDisplayname: string;
  ModelName: string;
  ProviderId?: number;
  RequestUrl: string;
  RequestType: string;
  BearerToken: string;
  RequestBody: string;
  DisplaySerial?: number;
  OrgId?: number;
  IsDefault?: boolean;
  IsActive?: boolean;
  CreatedBy?: number;
  CreatedOn?: Date;
  LastModifiedBy?: number;
  LastModifiedOn?: Date;
}
